import React from 'react'
import './style.scss'

const Card = ({ src, texts }) => {
  return (
    <div className="card-content">
      <div className="card-image-wrapper">
        <img className="card-image" src={src || ''} alt="Card Image" />
      </div>
      <div className="card-texts">
        {Object.values(texts).map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </div>
    </div>
  )
}

export default Card
